(function() {
  function reinitKlaviyoWidgets() {
    var widgets = document.querySelectorAll('[data-product-recommendations] .klaviyo-star-rating-widget');
    widgets.forEach(function(widget) {
      if (widget.innerHTML === '') {
        // Widget ko remove karke fresh div se replace karo
        var parent = widget.parentNode;
        var newWidget = document.createElement('div');
        newWidget.className = 'klaviyo-star-rating-widget';
        newWidget.setAttribute('data-id', widget.getAttribute('data-id'));
        newWidget.setAttribute('data-product-title', widget.getAttribute('data-product-title'));
        newWidget.setAttribute('data-product-type', widget.getAttribute('data-product-type'));
        parent.replaceChild(newWidget, widget);
      }
    });

    // Klaviyo ko force refresh karo
    var event = new CustomEvent('klaviyo:reviews:reinit', { bubbles: true });
    document.dispatchEvent(event);
  }

  document.addEventListener('DOMContentLoaded', function() {
    var recContainer = document.querySelector('[data-product-recommendations]');
    if (!recContainer) return;

    var observer = new MutationObserver(function(mutations) {
      var added = false;
      mutations.forEach(function(m) {
        if (m.addedNodes.length > 0) added = true;
      });
      if (added) {
        setTimeout(reinitKlaviyoWidgets, 1200);
      }
    });

    observer.observe(recContainer, { childList: true, subtree: false });
  });
})();